angular.module('jv.requisition.retract.controller', [])
.controller('ReqsRetractCtrl', ['$scope', 'Reqs', '$routeParams', '$http',
function ($scope, Reqs) {
    $scope.retractData = {};
    $scope.retractData.reqSubject = false;

    $scope.$watch('retractModal.show', function (newValue) {
        if (newValue) {
            $scope.flags.loading = true;
            var data = {
                j: $scope.requisitions.jobDetails.EId
            };
            Reqs.retractJob(data, function (response, code) {
                if (code === 200) {
                    $scope.retractData = response;
                    $scope.flags.loading = false;
                }
            });
        }
    });

    $scope.cancel = function () {
        $scope.retractModal.show = false;
        $scope.retractData = {};
    };

    $scope.submitRetractRequest = function () {
        $scope.flags.loading = true;
        $scope.retractData.reqSubject = false;
        if (!$scope.retractData.retractJobTemplate.subject || $scope.retractData.retractJobTemplate.subject.trim() === '') {
            $scope.retractData.reqSubject = true;
            $scope.flags.loading = false;
            return;
        }

        var data = {
            j: $scope.requisitions.jobDetails.EId,
            subject: $scope.retractData.retractJobTemplate.subject,
            message: $scope.retractData.retractJobTemplate.body,
            id: $scope.retractData.currentJobApprover.user.EId,
            locale: $scope.retractData.retractJobTemplate.locale
        };
        Reqs.sendRetractMessage(data, function (response, code) {
            if (response.msgInfo === 200 && code === 200) {
                $scope.retractModal.show = false;
                $scope.retractData = {};
                window.location = (('../../modules/requisitions/tabs.html?code=retracted&readMode=0#/summary/' + $scope.params.id + '/' + $scope.params.index + '/' + $scope.params.count + '/' + $scope.params.query).replace(/\/undefined/gi, ''));
            }
        }, function (response) {
            if (response === 'invalid') {
                $scope.retractModal.show = false;
                $scope.retractData = {};
            }
        });
        $scope.flags.loading = false;
    };
}
]);
